import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getInsuranceTypesList } from "../../../../../../../services/tasyInsuranceType.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const PlanPriceFormation = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(getInsuranceTypesList);

  const [planPriceFormations, setPlanPriceFormations] = useState<ISelectType[]>([]);

  const params = useMemo(() => {
    return {
      Identifier: 1669,
    };
  }, []);

  const fetchPlanPriceFormation = useCallback(async () => {
    const { data, success } = await sendRequest(params);
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifierValue,
        name: item.domainValueName,
      }));

      setPlanPriceFormations(newData);
    }
  }, [sendRequest, params]);

  useEffect(() => {
    fetchPlanPriceFormation();
  }, [fetchPlanPriceFormation]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={planPriceFormations}
        name="uBusIntegrationRuleMovPlanPriceFormations"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "plan_price_formation")}
        keepOpenOnSelect
      />
    </Grid>
  );
});
